export function getDataServicePage(postsURL: string) {
  return <T>(data: T | undefined) => {
    if (data) {
      return;
    }

    return postsURL;
  };
}
